"use client";

import { motion } from "framer-motion";

const ProgramActivities = () => {
  const activities = [
    {
      id: 1,
      title: "Ideation and Problem-Solving Workshops",
      description:
        "We help students identify real-world problems and brainstorm potential solutions through structured workshops and collaborative sessions.",
    },
    {
      id: 2,
      title: "Business Plan Development",
      description:
        "From defining the target market to outlining financial projections, we guide students in crafting comprehensive business plans.",
    },
    {
      id: 3,
      title: "Prototyping and MVP Creation",
      description:
        "Hands-on sessions to develop working prototypes and minimum viable products (MVPs) that bring ideas to life.",
    },
    {
      id: 4,
      title: "Go-to-Market Strategy",
      description:
        "Guidance on launching products, reaching target audiences, and establishing a strong market presence.",
    },
    {
      id: 5,
      title: "IPR Awareness and Commercialisation",
      description:
        "Awareness sessions and guidance for drafting and applying IPR to faculty members and students.",
    },
    {
      id: 6,
      title: "Startup Mentoring and Hand Holding",
      description:
        "Mentoring startup founders starting from idea validation, preparing business Canvas Model up to making them investment ready.",
    },
  ];

  return (
    <section className="py-16  bg-gray-100">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-orange-500 mb-4">Programmes and Activities</h2>
          <p className="text-lg text-gray-600">
            The Incubation Cell and IIC provide a structured pathway to support innovators at every stage of their entrepreneurial journey:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((activity) => (
            <motion.div
              key={activity.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: activity.id * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative overflow-hidden border border-gray-200/60 bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:border-orange-200 hover:shadow-2xl hover:shadow-orange-100/30"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-orange-50/0 to-amber-50/0 transition-all duration-500 group-hover:from-orange-50/60 group-hover:to-amber-50/40" />
              <div className="relative flex flex-col space-y-6">
                <div className="space-y-3">
                  <div className="md:text-4xl text-2xl font-bold tracking-tight text-gray-900 transition-colors duration-300 group-hover:text-[#FC9D00]" style={{ fontFamily: "saans-bold" }}>
                    {activity.title}
                  </div>
                  <p className="text-base leading-relaxed text-gray-600" style={{ fontFamily: "saans-regular" }}>
                    {activity.description}
                  </p>
                </div>
              </div>
              <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-gradient-to-br from-orange-200 to-amber-200 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-60" />
              <div className="absolute bottom-0 left-0 right-0 h-1 origin-left scale-x-0 rounded-full bg-gradient-to-r from-[#FC9D00] to-[#FF8800] transition-transform duration-500 group-hover:scale-x-100" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramActivities;
